module.exports = __webpack_public_path__ + "static/img/wzry-coreTechnology2.e8301a63.png";